/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getHistoryList = (landId, payload, callback) =>
  req.list(
    c.GET_LAND_HISTORY_LIST,
    `api/v1/rpt/administrator/land/land_applications/${landId}/land_history_logs?isPaginate=1`,
    payload,
    callback
  );

  export const getLandApplicationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_APPLICATIONS,
    '/api/v1/rpt/administrator/land/land_applications',
    payload,
    callback
  );

export const getSingleLandApplication = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}`,
    payload,
    callback
  );

export const createLandApplication = (payload, callback) =>
  req.create(
    c.CREATE_LAND_APPLICATION,
    '/api/v1/rpt/administrator/land/land_applications/',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getLandAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    callback
  );

export const getSingleLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    callback
  );

export const createLandAppraisal = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    callback
  );

export const getSingleLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    callback
  );

export const createLandPropertyAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandPropertyAssessment = (id, landPropertyAssessmentId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandMarketValueList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    callback
  );

export const getSingleLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    callback
  );

export const createLandMarketValue = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandMarketValue = (id, landMarketValueId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_market_values/${landMarketValueId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getAdjustmentFactorList = (payload, callback) =>
  req.list(
    c.GET_ADJUSTMENT_FACTOR_LIST,
    'api/v1/rpt/administrator/land/settings/land_adjustment_factors?isPaginate=1',
    payload,
    callback
  );

export const getLandRecordofSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    callback
  );

export const createLandRecordofSupAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandRecordofSupAssessment = (id, landRecordofSupAssessmentId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_TRANSACTION,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_transactions`,
    payload,
    callback
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    callback
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USES,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    callback
  );

export const getLandOwnerList = (payload, callback) =>
  req.list(
    c.GET_LAND_OWNER,
    'api/v1/rpt/administrator/land/land_owners',
    payload,
    callback
  );

export const getSingleLandOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );